import { render, staticRenderFns } from "./SpinnerCmpt.vue?vue&type=template&id=6828899c&"
import script from "./SpinnerCmpt.vue?vue&type=script&lang=js&"
export * from "./SpinnerCmpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports